import i18next from 'i18next';

import { uploadDocument } from 'common/api/v1/historicalDocument';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import * as afterSalesSettingsSelectors from '../../afterSalesSettings/selectors';
import {
    SET_INTEGRATION_ENERGY_DATA,
    UPLOAD_FILE,
    UPLOAD_FILE_FAILURE,
    UPLOAD_FILE_SUCCESS,
} from '../actionTypes';
import { UPLOAD_ORIGINS } from '../constants';
import { populateFieldsFromCSVData } from '../helpers';
import { actions } from '../reducer';

import initializeForm from './initializeForm';
import setConfigCsvImportModal from './setConfigCsvImportModal';

export default ({ data, getValues, result }) =>
    (dispatch, getState) => {
        if (!data?.file) return;

        dispatch(actions[UPLOAD_FILE]());

        const state = getState();
        const afterSalesSettingsId =
            afterSalesSettingsSelectors.getAfterSalesSettingsDataId(state);

        dispatch(
            alerts.actions.show({
                confirmText: i18next.t('Back'),
                hideButtons: true,
                messages: [
                    i18next.t(
                        'Please wait a moment as the information is processed',
                    ),
                ],
                title: i18next.t('Loading').concat('...'),
                type: alerts.ALERT_TYPE_ALERT,
                variant: 'info',
            }),
        );

        uploadDocument(afterSalesSettingsId, data?.file)
            .then((response) => {
                const rateConfiguration =
                    afterSalesSettingsSelectors.getScheduleRateConfiguration(
                        state,
                    );

                const ratesDictionary =
                    afterSalesSettingsSelectors.getRatesDictionary(state);

                const responseData = response?.data?.data || {};

                const rateId = getValues('rate');

                const { initialDate, finalDate, fields } =
                    populateFieldsFromCSVData({
                        columnsFormat: data?.columnsFormat,
                        columnsMatch: data?.columnsMatch,
                        getValues,
                        rate: ratesDictionary?.[rateId],
                        rateConfiguration,
                        result,
                    });

                const { demand, ...restFields } = fields;

                const newValues = getValues();

                dispatch(
                    initializeForm({
                        ...newValues,
                        file: responseData?.url,
                        final_date: finalDate,
                        initial_date: initialDate,
                        upload_origin: UPLOAD_ORIGINS.CSV,
                        demand,
                    }),
                );

                dispatch(actions[SET_INTEGRATION_ENERGY_DATA](restFields));

                dispatch(alerts.actions.close());

                dispatch(setConfigCsvImportModal({ isOpen: false }));
                dispatch(actions[UPLOAD_FILE_SUCCESS]());
            })
            .catch((error) => {
                dispatch(actions[UPLOAD_FILE_FAILURE]());
                dispatch(alerts.actions.close());
                dispatch(setConfigCsvImportModal({ isOpen: false }));
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
